var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebPrCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_5008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1866 25.5427H21.5119V7.12137C21.5119 6.89005 21.3246 6.7027 21.0932 6.7027C20.8619 6.7027 20.6746 6.89005 20.6746 7.12137V25.5427H18.1626V18.4255C18.1626 18.1942 17.9752 18.0068 17.7439 18.0068H9.37056C9.13925 18.0068 8.95189 18.1942 8.95189 18.4255V25.5427H6.43989V2.51589C6.43989 2.28458 6.62724 2.09722 6.85856 2.09722H20.2559C20.4872 2.09722 20.6746 2.28458 20.6746 2.51589V5.4467C20.6746 5.67801 20.8619 5.86536 21.0932 5.86536C21.3246 5.86536 21.5119 5.67801 21.5119 5.4467V2.51589C21.5119 1.82196 20.9498 1.25989 20.2559 1.25989H6.85856C6.16463 1.25989 5.60255 1.82196 5.60255 2.51589V25.5427H3.92788C3.69657 25.5427 3.50922 25.7301 3.50922 25.9614C3.50922 26.1927 3.69657 26.3801 3.92788 26.3801H23.1866C23.4179 26.3801 23.6052 26.1927 23.6052 25.9614C23.6052 25.7301 23.4179 25.5427 23.1866 25.5427ZM13.1386 25.5427H9.78923V18.8441H13.1386V25.5427ZM17.3252 25.5427H13.9759V18.8441H17.3252V25.5427ZM18.0146 5.19721H15.5026C15.2713 5.19721 15.0839 5.38456 15.0839 5.61587V8.12788C15.0839 8.35919 15.2713 8.54655 15.5026 8.54655H18.0146C18.2459 8.54655 18.4333 8.35919 18.4333 8.12788V5.61587C18.4333 5.38456 18.2459 5.19721 18.0146 5.19721ZM17.596 7.70921H15.9213V6.03454H17.596V7.70921ZM18.0146 11.1566H15.5026C15.2713 11.1566 15.0839 11.344 15.0839 11.5753V14.0873C15.0839 14.3186 15.2713 14.506 15.5026 14.506H18.0146C18.2459 14.506 18.4333 14.3186 18.4333 14.0873V11.5753C18.4333 11.344 18.2459 11.1566 18.0146 11.1566ZM17.596 13.6686H15.9213V11.994H17.596V13.6686ZM11.6117 5.19721H9.09971C8.8684 5.19721 8.68105 5.38456 8.68105 5.61587V8.12788C8.68105 8.35919 8.8684 8.54655 9.09971 8.54655H11.6117C11.843 8.54655 12.0304 8.35919 12.0304 8.12788V5.61587C12.0304 5.38456 11.843 5.19721 11.6117 5.19721ZM11.1931 7.70921H9.51838V6.03454H11.1931V7.70921ZM11.612 11.1566H9.09998C8.86867 11.1566 8.68131 11.344 8.68131 11.5753V14.0873C8.68131 14.3186 8.86867 14.506 9.09998 14.506H11.612C11.8433 14.506 12.0307 14.3186 12.0307 14.0873V11.5753C12.0307 11.344 11.8433 11.1566 11.612 11.1566ZM11.1933 13.6686H9.51865V11.994H11.1933V13.6686Z",
    fill: "url(#paint0_linear_169_5008)",
    stroke: "url(#paint1_linear_169_5008)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_5008",
    x1: -1.77064,
    y1: 152.112,
    x2: 79.738,
    y2: 115.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_5008",
    x1: -1.77064,
    y1: 152.112,
    x2: 79.738,
    y2: 115.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_5008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.5963,
    height: 25.8396,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.0870361 26.38)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebPrCompany);
export default __webpack_public_path__ + "static/media/web_PR_company.d0d43d352efb10b7c579fac12a1dbf1d.svg";
export { ForwardRef as ReactComponent };